// extracted by mini-css-extract-plugin
module.exports = {"drawer":"Drawer_drawer__2nrIY","link":"Drawer_link__2-TIO","link__active":"Drawer_link__active__1xw6w"};